module.exports = __webpack_public_path__ + "assets/moneycard-8d8540.svg";